import {validateQuidAndRetrieveMenus} from '../../helpers/apiHelper';

export const validateQuidService = async (quid: string) => {
  const response = await validateQuidAndRetrieveMenus(quid);
  return response;
}
